<div class="q9ma-password-control-container">
  <mat-form-field>
    <input
      data-qa="login-password-field"
      matInput
      [required]="required"
      [formControl]="control"
      [placeholder]="placeholder | translate"
      [type]="showPassword ? 'text' : 'password'"
      [attr.disabled]="disabled ? '' : null" />
    <mat-label>{{ label | translate }}</mat-label>

    <q9-icon-button
      (click)="showPassword = !showPassword"
      [icon]="showPassword ? 'eye_open' : 'eye_close'"></q9-icon-button>

    <mat-error *ngIf="ngControl?.invalid && error && isLoginFlow">
      {{ error | translate }}
    </mat-error>

    <mat-error *ngIf="!ngControl?.hasError('whitespace') && !isLoginFlow">
      {{ 'SIGNUP.PASS_VALIDATION_STRONG' | translate }}
    </mat-error>

    <mat-error *ngIf="ngControl?.hasError('whitespace')">
      {{ 'SIGNUP.PASS_VALIDATION_WHITESPACE' | translate }}
    </mat-error>
  </mat-form-field>
</div>
